import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-helpline-widget',
  templateUrl: './helpline-widget.component.html',
  styleUrls: []
})
export class HelplineWidgetComponent implements OnInit {

  @Input() phoneNumber: string;

  get imageSrc(): string {
    return './assets/images/helpline-employee.png';
  }

  constructor() { }

  ngOnInit(): void {
  }

}
